import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.png';
import _imports_1 from '@/assets/img/logo-h.png';
const _withScopeId = n => (_pushScopeId("data-v-3cb85103"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sticky_container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("figure", {
  class: "img_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, "首页", -1));
const _hoisted_5 = {
  class: "text_box"
};
const _hoisted_6 = {
  class: "text_box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("类器官建模"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_8 = {
  class: "ul"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("类器官药物筛选"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_10 = {
  class: "ul"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("精准医学"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_12 = {
  class: "ul"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("单细胞测序"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_14 = {
  class: "ul"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://database.aimingmed.com/#/login"
}, "数据库")], -1));
const _hoisted_16 = {
  class: "text_box"
};
const _hoisted_17 = {
  class: "text_box"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", null, "公司介绍")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, "联系我们", -1));
const _hoisted_20 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "language",
  href: "https://en.aimingmed.com/"
}, "English", -1));
const _hoisted_22 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_23 = {
  style: {
    "margin": "0 10rem 0 20rem"
  }
};
const _hoisted_24 = {
  class: "my-center"
};
const _hoisted_25 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_26 = {
  key: 0,
  class: "my-center-after"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "angle"
}, null, -1));
const _hoisted_28 = {
  class: "right"
};
const _hoisted_29 = {
  class: "phone"
};
const _hoisted_30 = {
  class: "my-menu-box"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "购物车", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "我的订单", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "收货地址", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "我的下载", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "会员中心", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "积分明细", -1));
const _hoisted_37 = {
  class: "my-menu-bottom"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "每日签到", -1));
const _hoisted_39 = {
  key: 0,
  class: "my-center-after"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "angle"
}, null, -1));
const _hoisted_41 = {
  class: "my-sign-box"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "我的积分", -1));
const _hoisted_43 = {
  class: "my-integral"
};
const _hoisted_44 = {
  class: "sticky_container"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("figure", {
  class: "img_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_46 = {
  class: "top"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, "首页", -1));
const _hoisted_48 = {
  class: "text_box"
};
const _hoisted_49 = {
  class: "text_box"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("类器官建模"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_51 = {
  class: "ul"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("类器官药物筛选"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_53 = {
  class: "ul"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("精准医学"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_55 = {
  class: "ul"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [/*#__PURE__*/_createTextVNode("单细胞测序"), /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-angle-right"
})], -1));
const _hoisted_57 = {
  class: "ul"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://database.aimingmed.com/#/login"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, "数据库")], -1));
const _hoisted_59 = {
  class: "text_box"
};
const _hoisted_60 = {
  class: "text_box"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", null, "公司介绍")], -1));
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_box"
}, "联系我们", -1));
const _hoisted_63 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "language",
  href: "https://en.aimingmed.com/"
}, "English", -1));
const _hoisted_65 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_66 = {
  style: {
    "margin": "0 10rem 0 20rem"
  }
};
const _hoisted_67 = {
  class: "my-center"
};
const _hoisted_68 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_69 = {
  key: 0,
  class: "my-center-after"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "angle"
}, null, -1));
const _hoisted_71 = {
  class: "right"
};
const _hoisted_72 = {
  class: "phone"
};
const _hoisted_73 = {
  class: "my-menu-box"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "购物车", -1));
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "我的订单", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "收货地址", -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "我的下载", -1));
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "会员中心", -1));
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "积分明细", -1));
const _hoisted_80 = {
  class: "my-menu-bottom"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#0066b5"
  }
}, "每日签到", -1));
const _hoisted_82 = {
  key: 0,
  class: "my-center-after"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "angle"
}, null, -1));
const _hoisted_84 = {
  class: "my-sign-box"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "我的积分", -1));
const _hoisted_86 = {
  class: "my-integral"
};
import { onMounted, ref, watch } from "vue";
import { useHeadComponentStore } from "@/store";
import api, { getIfSign, sign } from "@/http/api";
import { baseURL } from "@/config";
import { useRouter } from "vue-router";
import { useUserStore } from "@/store";
import { Download, Goods, Location, Search, ShoppingCart, User } from "@element-plus/icons-vue";
export default {
  __name: 'HeadComponent',
  setup(__props) {
    const router = useRouter();
    const userStore = useUserStore();
    const userInfo = ref({});
    watch(() => userStore.userInfo, value => {
      userInfo.value = value;
    }, {
      deep: true,
      immediate: true
    });
    function toLogin() {
      router.push("/login");
    }
    const hcStore = useHeadComponentStore();
    let element;
    onMounted(() => {
      element = document.getElementById("sticky");
      hcStore.height = element.clientHeight;
      window.addEventListener("scroll", Scroll);
      getInfo();
    });
    const Scroll = () => {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop > element.clientHeight) {
        element.style.visibility = "visible";
        element.style.opacity = 1;
        element.style.top = "0";
      } else {
        element.style.visibility = "hidden";
        element.style.opacity = 0;
        element.style.top = "-50rem";
      }
    };
    const categoryList = ref([]);
    async function getCategoryList() {
      let res = await api.getGoodsCategoryList();
      categoryList.value = res;
    }
    async function getInfo() {
      const res = await fetch(baseURL + "/h5/member/info", {
        method: "GET",
        headers: {
          Authorization: window.localStorage.getItem("token") ? "Bearer " + window.localStorage.getItem("token") : ""
        }
      });
      res.json().then(response => {
        if (response.phone) {
          userStore.setUserInfo(response);
          userInfo.value = userStore.userInfo;
        }
      });
    }
    getCategoryList();
    function toPath(path) {
      console.log("toPath");
      router.push({
        path
      });
    }
    function exitLogin() {
      userStore.clearUserInfo();
      router.push({
        path: "/"
      });
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    }
    const showMenu = ref(false); //是否显示菜单
    const showMenu1 = ref(false); //是否显示菜单

    const showQianDao = ref(false); //是否显示签到

    const isQianDaoLoading = ref(false);
    const ifSign = ref(false); //是否已签到

    //当鼠标移动到每日签到上 查询签到信息
    async function getQianDaoInfo() {
      isQianDaoLoading.value = true;
      showQianDao.value = true;
      showMenu1.value = false;
      let res = await getIfSign();
      console.log(res);
      ifSign.value = res;
      isQianDaoLoading.value = false;
    }
    async function toSign() {
      await sign();
      isQianDaoLoading.value = true;
      let res = await getIfSign();
      ifSign.value = res;
      getInfo();
      isQianDaoLoading.value = false;
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("nav", {
        onMouseleave: _cache[10] || (_cache[10] = $event => {
          showMenu1.value = false;
          showQianDao.value = false;
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'product',
          query: {
            c: 'category',
            id: 1
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createTextVNode(" 产品中心 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'category',
            query: {
              c: 'category',
              isFeature: 'Y'
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("特色产品 ")]),
          _: 1
        })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.id
          }, [_createVNode(_component_router_link, {
            to: {
              name: 'category',
              query: {
                c: 'category',
                id: item.id
              }
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 128))])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'service',
          query: {
            c: 'category',
            id: 2
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createTextVNode(" 技术服务 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_hoisted_7, _createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewA',
            query: {
              c: 'show',
              id: 16
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官建模 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewB',
            query: {
              c: 'show',
              id: 19
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官鉴定 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewC',
            query: {
              c: 'show',
              id: 18
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("Immutuor™类器官与免疫细胞共培养 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_9, _createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewD',
            query: {
              c: 'show',
              id: 20
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官高通量药物筛选 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewE',
            query: {
              c: 'show',
              id: 22
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官毒理学测试 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_11, _createElementVNode("ul", _hoisted_12, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewF',
            query: {
              c: 'show',
              id: 21
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("妙准康®类器官个体化药敏检测 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_13, _createElementVNode("ul", _hoisted_14, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewG',
            query: {
              c: 'show',
              id: 23
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("单细胞测序 ")]),
          _: 1
        })])])])])])]),
        _: 1
      }), _hoisted_15, _createVNode(_component_router_link, {
        to: "/search"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createTextVNode(" 资源与支持 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'search'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("产品资料 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'literature'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("艾名客户文章精选 ")]),
          _: 1
        })])])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'about',
          query: {
            c: 'category',
            id: 25
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createTextVNode(" 关于我们 "), _createElementVNode("ul", null, [_hoisted_18, _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'companyNews',
            query: {
              c: 'category',
              id: 26
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("公司动态 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'join',
            query: {
              c: 'category',
              id: 35
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("加入艾名 ")]),
          _: 1
        })])])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'contact',
          query: {
            c: 'category',
            id: 6
          }
        }
      }, {
        default: _withCtx(() => [_hoisted_19]),
        _: 1
      })]), _createElementVNode("div", _hoisted_20, [_hoisted_21, userInfo.value.phone ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_image, {
        style: {
          "width": "40rem",
          "height": "40rem",
          "border-radius": "50%"
        },
        src: _unref(baseURL) + userInfo.value.avatar
      }, null, 8, ["src"])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
        class: "center-btn",
        onClick: _cache[9] || (_cache[9] = _withModifiers($event => toPath('/mine/vip'), ["stop"]))
      }, [_createElementVNode("div", {
        onMousemove: _cache[0] || (_cache[0] = $event => {
          showMenu1.value = true;
          showQianDao.value = false;
        })
      }, " 个人中心 ", 32), showMenu1.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => toPath('/mine/vip'), ["stop"])),
        class: "menu-user-box"
      }, [_createVNode(_component_el_image, {
        src: _unref(baseURL) + userInfo.value.avatar,
        style: {
          "width": "50rem",
          "height": "50rem",
          "border-radius": "50%"
        }
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, _toDisplayString(userInfo.value.nickname), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(userInfo.value.phoneHidden), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => toPath('/mine/cart'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ShoppingCart))]),
        _: 1
      }), _hoisted_31]), _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => toPath('/mine/order'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Goods))]),
        _: 1
      }), _hoisted_32]), _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => toPath('/mine/address'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Location))]),
        _: 1
      }), _hoisted_33]), _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => toPath('/mine/download'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Download))]),
        _: 1
      }), _hoisted_34]), _createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = _withModifiers($event => toPath('/mine/vip'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(User))]),
        _: 1
      }), _hoisted_35]), _createElementVNode("div", {
        onClick: _cache[7] || (_cache[7] = _withModifiers($event => toPath('/mine/integralDetail'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Search))]),
        _: 1
      }), _hoisted_36])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = _withModifiers($event => toPath('/password'), ["stop"])),
        class: "item"
      }, " 修改密码 "), _createElementVNode("div", {
        onClick: _withModifiers(exitLogin, ["stop"]),
        class: "item"
      }, "退出登录")])])) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
        to: "/mine/cart"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 30,
          color: "#fff"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ShoppingCart))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", {
        onClick: _withModifiers(getQianDaoInfo, ["stop"]),
        class: "qiandao-btn"
      }, [_hoisted_38, showQianDao.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("div", _hoisted_43, _toDisplayString(userInfo.value.integral), 1), _createVNode(_component_el_button, {
        disabled: ifSign.value == 1,
        size: "large",
        color: "#0066b5",
        onClick: toSign
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(ifSign.value == 1 ? "已签到" : "立即签到"), 1)]),
        _: 1
      }, 8, ["disabled"])])])), [[_directive_loading, isQianDaoLoading.value]]) : _createCommentVNode("", true)])])])])])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: toLogin,
        style: {
          "color": "#fff",
          "margin-left": "20rem",
          "cursor": "pointer"
        }
      }, " 登录 "))])])], 32), _createElementVNode("nav", {
        onMouseleave: _cache[21] || (_cache[21] = $event => {
          showMenu.value = false;
          showQianDao.value = false;
        }),
        id: "sticky"
      }, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_45]),
        _: 1
      }), _createElementVNode("div", _hoisted_46, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_47]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'product',
          query: {
            c: 'category',
            id: 1
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createTextVNode(" 产品中心 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'category',
            query: {
              c: 'category',
              isFeature: 'Y'
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("特色产品 ")]),
          _: 1
        })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.id
          }, [_createVNode(_component_router_link, {
            to: {
              name: 'category',
              query: {
                c: 'category',
                id: item.id
              }
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 128))])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'service',
          query: {
            c: 'category',
            id: 2
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createTextVNode(" 技术服务 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_hoisted_50, _createElementVNode("ul", _hoisted_51, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewA',
            query: {
              c: 'show',
              id: 16
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官建模 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewB',
            query: {
              c: 'show',
              id: 19
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官鉴定 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewC',
            query: {
              c: 'show',
              id: 18
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("Immutuor™类器官与免疫细胞共培养 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_52, _createElementVNode("ul", _hoisted_53, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewD',
            query: {
              c: 'show',
              id: 20
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官高通量药物筛选 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewE',
            query: {
              c: 'show',
              id: 22
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("类器官毒理学测试 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_54, _createElementVNode("ul", _hoisted_55, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewF',
            query: {
              c: 'show',
              id: 21
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("妙准康®类器官个体化药敏检测 ")]),
          _: 1
        })])])]), _createElementVNode("li", null, [_hoisted_56, _createElementVNode("ul", _hoisted_57, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'viewG',
            query: {
              c: 'show',
              id: 23
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("单细胞测序 ")]),
          _: 1
        })])])])])])]),
        _: 1
      }), _hoisted_58, _createVNode(_component_router_link, {
        to: "/search"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createTextVNode(" 资源与支持 "), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'search'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("产品资料 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'literature'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("艾名客户文章精选 ")]),
          _: 1
        })])])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'about',
          query: {
            c: 'category',
            id: 25
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createTextVNode(" 关于我们 "), _createElementVNode("ul", null, [_hoisted_61, _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'companyNews',
            query: {
              c: 'category',
              id: 26
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("公司动态 ")]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: {
            name: 'join',
            query: {
              c: 'category',
              id: 26
            }
          }
        }, {
          default: _withCtx(() => [_createTextVNode("加入艾名 ")]),
          _: 1
        })])])])]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'contact',
          query: {
            c: 'category',
            id: 6
          }
        }
      }, {
        default: _withCtx(() => [_hoisted_62]),
        _: 1
      })]), _createElementVNode("div", _hoisted_63, [_hoisted_64, userInfo.value.phone ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createVNode(_component_el_image, {
        style: {
          "width": "40rem",
          "height": "40rem",
          "border-radius": "50%"
        },
        src: _unref(baseURL) + userInfo.value.avatar
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", {
        class: "center-btn",
        onClick: _cache[20] || (_cache[20] = _withModifiers($event => toPath('/mine/vip'), ["stop"]))
      }, [_createElementVNode("div", {
        onMousemove: _cache[11] || (_cache[11] = $event => showMenu.value = true),
        style: {
          "color": "#0066b5"
        }
      }, " 个人中心 ", 32), showMenu.value ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", {
        onClick: _cache[12] || (_cache[12] = _withModifiers($event => toPath('/mine/vip'), ["stop"])),
        class: "menu-user-box"
      }, [_createVNode(_component_el_image, {
        src: _unref(baseURL) + userInfo.value.avatar,
        style: {
          "width": "50rem",
          "height": "50rem",
          "border-radius": "50%"
        }
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", null, _toDisplayString(userInfo.value.nickname), 1), _createElementVNode("div", _hoisted_72, _toDisplayString(userInfo.value.phoneHidden), 1)])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", {
        onClick: _cache[13] || (_cache[13] = _withModifiers($event => toPath('/mine/cart'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ShoppingCart))]),
        _: 1
      }), _hoisted_74]), _createElementVNode("div", {
        onClick: _cache[14] || (_cache[14] = _withModifiers($event => toPath('/mine/order'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Goods))]),
        _: 1
      }), _hoisted_75]), _createElementVNode("div", {
        onClick: _cache[15] || (_cache[15] = _withModifiers($event => toPath('/mine/address'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Location))]),
        _: 1
      }), _hoisted_76]), _createElementVNode("div", {
        onClick: _cache[16] || (_cache[16] = _withModifiers($event => toPath('/mine/download'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Download))]),
        _: 1
      }), _hoisted_77]), _createElementVNode("div", {
        onClick: _cache[17] || (_cache[17] = _withModifiers($event => toPath('/mine/vip'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(User))]),
        _: 1
      }), _hoisted_78]), _createElementVNode("div", {
        onClick: _cache[18] || (_cache[18] = _withModifiers($event => toPath('/mine/integralDetail'), ["stop"])),
        class: "my-menu"
      }, [_createVNode(_component_el_icon, {
        size: 17,
        color: "#444"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Search))]),
        _: 1
      }), _hoisted_79])]), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", {
        onClick: _cache[19] || (_cache[19] = _withModifiers($event => toPath('/password'), ["stop"])),
        class: "item"
      }, " 修改密码 "), _createElementVNode("div", {
        onClick: _withModifiers(exitLogin, ["stop"]),
        class: "item"
      }, "退出登录")])])) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
        to: "/mine/cart"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 30,
          color: "#0066b5"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ShoppingCart))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", {
        onClick: _withModifiers(getQianDaoInfo, ["stop"]),
        class: "qiandao-btn"
      }, [_hoisted_81, showQianDao.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [_hoisted_83, _createElementVNode("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, _toDisplayString(userInfo.value.integral), 1), _createVNode(_component_el_button, {
        disabled: ifSign.value == 1,
        size: "large",
        color: "#0066b5",
        onClick: toSign
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(ifSign.value == 1 ? "已签到" : "立即签到"), 1)]),
        _: 1
      }, 8, ["disabled"])])])), [[_directive_loading, isQianDaoLoading.value]]) : _createCommentVNode("", true)])])])])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: toLogin,
        style: {
          "color": "#0166b6",
          "margin-left": "20rem",
          "cursor": "pointer"
        }
      }, " 登录 "))])])], 32)], 64);
    };
  }
};